import React from 'react';
import './ComingSoon.css';

const ComingSoon = () => (
  <div className="comingsoon-main">
    <h1 className="comingsoon-title">Coming Soon 🚀</h1>
    <p className="comingsoon-desc">This project or application will be available soon.<br />Stay tuned for updates!</p>
  </div>
);

export default ComingSoon;
